export default __webpack_public_path__ + "static/media/NotificationX.33d129dc.svg";